const DEPTHS = [22, 12, 34, 16, 40, 14, 30, 18, 36, 12, 26, 38, 16, 32, 14, 24];
const DRIP_PATH =
  "M0 0H1440V14" + DEPTHS.map((d) => `a45 ${d} 0 0 1 -90 0`).join(" ") + "Z";

export const DripEdge = ({ className = "text-charcoal", flip = false }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 1440 64"
    preserveAspectRatio="none"
    className={`block h-10 w-full sm:h-14 ${flip ? "rotate-180" : ""} ${className}`}
  >
    <path fill="currentColor" d={DRIP_PATH} />
  </svg>
);
